export default __webpack_public_path__ + "static/media/O-156.007ce49b.png";